import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchDowloadDocument,
  fetchViewPatientResultEntryData,
} from "services/resultEntryReportMaster";
import { STALE_TIME } from "utils/constants";

const PatientDocument = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const patientData = location.state?.patientData;

  const hasDownloadedRef = useRef(false);

  useQuery(
    ["fetch-view-observation-result-entry"],
    () =>
      fetchViewPatientResultEntryData({
        appointment_id: patientData?.appointment_id,
      }),
    {
      staleTime: STALE_TIME,
      enabled: !!patientData?.appointment_id,
    }
  );

  const { data } = useQuery(
    ["fetch-signature", patientData?.appointment_id],
    () => fetchDowloadDocument({ appointment_id: patientData?.appointment_id }),
    {
      staleTime: STALE_TIME,
      enabled: !!patientData?.appointment_id,
    }
  );

  useEffect(() => {
    if (!hasDownloadedRef.current) {
      if (data?.data) {
        hasDownloadedRef.current = true;
        console.log("*************data*************", data?.data);

        let base64Data = data.data;
        let mimeType = "";
        let fileName = "";

        if (base64Data.startsWith("data:")) {
          const parts = base64Data.split(",");
          const header = parts[0];
          base64Data = parts[1];

          const mimeMatch = header.match(/data:([^;]+)/);
          mimeType = mimeMatch ? mimeMatch[1] : "";
        } else {
          if (base64Data.includes("image/jpeg")) {
            mimeType = "image/jpeg";
            base64Data = base64Data.split("base64")[1] || base64Data;
          } else if (base64Data.includes("application/pdf")) {
            mimeType = "application/pdf";
            base64Data = base64Data.split("base64")[1] || base64Data;
          }
        }

        if (mimeType.includes("image/jpeg")) {
          fileName = "patient_document.jpg";
        } else if (mimeType.includes("image/png")) {
          fileName = "patient_document.png";
        } else if (mimeType.includes("application/pdf")) {
          fileName = "patient_document.pdf";
        } else {
          fileName = "patient_document.pdf";
        }

        try {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mimeType });

          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error processing download:", error);
        }

        setTimeout(() => {
          navigate(-1);
        }, 2000);
      } else {
        alert("Document not found!");
        navigate("/patient-wise-search-report");
      }
    }
  }, [data, navigate]);

  return null;
};

export default PatientDocument;
